module.exports = __webpack_public_path__ + "img/icone_empresas.d47b4cdd.png";